// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ClaimWorkflowConfiguration,
    ClaimWorkflowConfigurationEditPayload,
    ClaimWorkflowConfigurationOptions,
    ClaimWorkflowStatusResponse,
    ProviderWorkerFunction,
    SupportCreateWorkerFunctionPayload,
    SupportWorkerFunction,
    WorkerDashboardResponse,
    WorkerRuleTesterPayload,
    ClaimWorkflowConfigurationEditPayloadToJSON,
    SupportCreateWorkerFunctionPayloadToJSON,
    WorkerRuleTesterPayloadToJSON,
    anyToJSON,
    ClaimWorkflowConfigurationFromJSON,
    ClaimWorkflowConfigurationOptionsFromJSON,
    ClaimWorkflowStatusResponseFromJSON,
    ProviderWorkerFunctionFromJSON,
    SupportWorkerFunctionFromJSON,
    WorkerDashboardResponseFromJSON,
} from '../models';

export interface CreateClaimWorkflowConfigurationRequest {
    requestBody: { [key: string]: { [key: string]: object; }; };
}

export interface CreateClaimWorkflowConfigurationProviderRequest {
    requestBody: { [key: string]: { [key: string]: object; }; };
}

export interface CreateSupportWorkerFunctionRequest {
    claimId: string;
    supportCreateWorkerFunctionPayload: SupportCreateWorkerFunctionPayload;
}

export interface GetProviderWorkerFunctionRequest {
    id: string;
}

export interface GetSupportWorkerFunctionRequest {
    id: string;
}

export interface ListProviderWorkerFunctionsRequest {
    filterClaimId: string;
}

export interface ListSupportWorkerFunctionsRequest {
    filterClaimId: string;
}

export interface TestDenialRuleConfigurationAgainstClaimRequest {
    workerRuleTesterPayload: WorkerRuleTesterPayload;
}

export interface TestDenialRuleConfigurationAgainstClaimProviderRequest {
    workerRuleTesterPayload: WorkerRuleTesterPayload;
}

export interface TestRejectionRuleConfigurationAgainstClaimRequest {
    workerRuleTesterPayload: WorkerRuleTesterPayload;
}

export interface TestRejectionRuleConfigurationAgainstClaimProviderRequest {
    workerRuleTesterPayload: WorkerRuleTesterPayload;
}

export interface UpdateClaimWorkflowConfigurationRequest {
    claimWorkflowConfigurationEditPayload: ClaimWorkflowConfigurationEditPayload;
}

export interface UpdateClaimWorkflowConfigurationProviderRequest {
    claimWorkflowConfigurationEditPayload: ClaimWorkflowConfigurationEditPayload;
}

/**
 * no description
 */
export class WorkerApi extends runtime.BaseAPI {

    /**
     * Creates or replaces a claim workflow configuration.
     * Create or Replace claim workflow configuration
     */
    async createClaimWorkflowConfigurationRaw(requestParameters: CreateClaimWorkflowConfigurationRequest): Promise<runtime.ApiResponse<ClaimWorkflowConfiguration>> {
        if (requestParameters['requestBody'] === null || requestParameters['requestBody'] === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling createClaimWorkflowConfiguration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/configuration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowConfigurationFromJSON(jsonValue));
    }

    /**
     * Creates or replaces a claim workflow configuration.
     * Create or Replace claim workflow configuration
     */
    async createClaimWorkflowConfiguration(requestParameters: CreateClaimWorkflowConfigurationRequest): Promise<ClaimWorkflowConfiguration> {
        const response = await this.createClaimWorkflowConfigurationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates or replaces a claim workflow configuration.
     * Create or Replace claim workflow configuration
     */
    async createClaimWorkflowConfigurationProviderRaw(requestParameters: CreateClaimWorkflowConfigurationProviderRequest): Promise<runtime.ApiResponse<ClaimWorkflowConfiguration>> {
        if (requestParameters['requestBody'] === null || requestParameters['requestBody'] === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling createClaimWorkflowConfigurationProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/configuration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowConfigurationFromJSON(jsonValue));
    }

    /**
     * Creates or replaces a claim workflow configuration.
     * Create or Replace claim workflow configuration
     */
    async createClaimWorkflowConfigurationProvider(requestParameters: CreateClaimWorkflowConfigurationProviderRequest): Promise<ClaimWorkflowConfiguration> {
        const response = await this.createClaimWorkflowConfigurationProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Records an Enter function executed by the worker for the specified claim.
     * Record a worker function execution
     */
    async createSupportWorkerFunctionRaw(requestParameters: CreateSupportWorkerFunctionRequest): Promise<runtime.ApiResponse<SupportWorkerFunction>> {
        if (requestParameters['claimId'] === null || requestParameters['claimId'] === undefined) {
            throw new runtime.RequiredError('claimId','Required parameter requestParameters.claimId was null or undefined when calling createSupportWorkerFunction.');
        }

        if (requestParameters['supportCreateWorkerFunctionPayload'] === null || requestParameters['supportCreateWorkerFunctionPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateWorkerFunctionPayload','Required parameter requestParameters.supportCreateWorkerFunctionPayload was null or undefined when calling createSupportWorkerFunction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.claimId !== undefined && requestParameters.claimId !== null) {
            headerParameters['claimId'] = String(requestParameters.claimId);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:function", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/functions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateWorkerFunctionPayloadToJSON(requestParameters['supportCreateWorkerFunctionPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportWorkerFunctionFromJSON(jsonValue));
    }

    /**
     * Records an Enter function executed by the worker for the specified claim.
     * Record a worker function execution
     */
    async createSupportWorkerFunction(requestParameters: CreateSupportWorkerFunctionRequest): Promise<SupportWorkerFunction> {
        const response = await this.createSupportWorkerFunctionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Return the claim aggregate counts for each bank user by status, step, and action.
     * Get aggregate data for the bank user for the current status of all claims
     */
    async getClaimStatusDashboardDataRaw(): Promise<runtime.ApiResponse<WorkerDashboardResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/dashboard/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkerDashboardResponseFromJSON(jsonValue));
    }

    /**
     * Return the claim aggregate counts for each bank user by status, step, and action.
     * Get aggregate data for the bank user for the current status of all claims
     */
    async getClaimStatusDashboardData(): Promise<WorkerDashboardResponse> {
        const response = await this.getClaimStatusDashboardDataRaw();
        return await response.value();
    }

    /**
     * Return the claim aggregate counts for bank user by status, step, and action.
     * Get aggregate data for the bank user for the current status of all claims
     */
    async getClaimStatusDashboardDataForUserRaw(): Promise<runtime.ApiResponse<WorkerDashboardResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/dashboard/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkerDashboardResponseFromJSON(jsonValue));
    }

    /**
     * Return the claim aggregate counts for bank user by status, step, and action.
     * Get aggregate data for the bank user for the current status of all claims
     */
    async getClaimStatusDashboardDataForUser(): Promise<WorkerDashboardResponse> {
        const response = await this.getClaimStatusDashboardDataForUserRaw();
        return await response.value();
    }

    /**
     * Return the html file that displays worker data
     * Get static HTML dashboard page
     */
    async getClaimStatusDashboardPageRaw(): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response);
    }

    /**
     * Return the html file that displays worker data
     * Get static HTML dashboard page
     */
    async getClaimStatusDashboardPage(): Promise<string> {
        const response = await this.getClaimStatusDashboardPageRaw();
        return await response.value();
    }

    /**
     * Gets the current claim workflow configuration for the authenticated bank user.
     * Get claim workflow configuration
     */
    async getClaimWorkflowConfigurationRaw(): Promise<runtime.ApiResponse<ClaimWorkflowConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowConfigurationFromJSON(jsonValue));
    }

    /**
     * Gets the current claim workflow configuration for the authenticated bank user.
     * Get claim workflow configuration
     */
    async getClaimWorkflowConfiguration(): Promise<ClaimWorkflowConfiguration> {
        const response = await this.getClaimWorkflowConfigurationRaw();
        return await response.value();
    }

    /**
     * Gets the available claim workflow configuration options.
     * Get claim workflow configuration options
     */
    async getClaimWorkflowConfigurationOptionsRaw(): Promise<runtime.ApiResponse<Array<ClaimWorkflowConfigurationOptions>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/configuration/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimWorkflowConfigurationOptionsFromJSON));
    }

    /**
     * Gets the available claim workflow configuration options.
     * Get claim workflow configuration options
     */
    async getClaimWorkflowConfigurationOptions(): Promise<Array<ClaimWorkflowConfigurationOptions>> {
        const response = await this.getClaimWorkflowConfigurationOptionsRaw();
        return await response.value();
    }

    /**
     * Gets the available claim workflow configuration options.
     * Get claim workflow configuration options
     */
    async getClaimWorkflowConfigurationOptionsProviderRaw(): Promise<runtime.ApiResponse<Array<ClaimWorkflowConfigurationOptions>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/configuration/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimWorkflowConfigurationOptionsFromJSON));
    }

    /**
     * Gets the available claim workflow configuration options.
     * Get claim workflow configuration options
     */
    async getClaimWorkflowConfigurationOptionsProvider(): Promise<Array<ClaimWorkflowConfigurationOptions>> {
        const response = await this.getClaimWorkflowConfigurationOptionsProviderRaw();
        return await response.value();
    }

    /**
     * Gets the current claim workflow configuration for the authenticated bank user.
     * Get claim workflow configuration
     */
    async getClaimWorkflowConfigurationProviderRaw(): Promise<runtime.ApiResponse<ClaimWorkflowConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowConfigurationFromJSON(jsonValue));
    }

    /**
     * Gets the current claim workflow configuration for the authenticated bank user.
     * Get claim workflow configuration
     */
    async getClaimWorkflowConfigurationProvider(): Promise<ClaimWorkflowConfiguration> {
        const response = await this.getClaimWorkflowConfigurationProviderRaw();
        return await response.value();
    }

    /**
     * Gets an Enter function execution by id.
     * Get a worker function execution
     */
    async getProviderWorkerFunctionRaw(requestParameters: GetProviderWorkerFunctionRequest): Promise<runtime.ApiResponse<ProviderWorkerFunction>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderWorkerFunction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:function"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/functions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderWorkerFunctionFromJSON(jsonValue));
    }

    /**
     * Gets an Enter function execution by id.
     * Get a worker function execution
     */
    async getProviderWorkerFunction(requestParameters: GetProviderWorkerFunctionRequest): Promise<ProviderWorkerFunction> {
        const response = await this.getProviderWorkerFunctionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an Enter function execution by id.
     * Get a worker function execution
     */
    async getSupportWorkerFunctionRaw(requestParameters: GetSupportWorkerFunctionRequest): Promise<runtime.ApiResponse<SupportWorkerFunction>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportWorkerFunction.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:function", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/functions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportWorkerFunctionFromJSON(jsonValue));
    }

    /**
     * Gets an Enter function execution by id.
     * Get a worker function execution
     */
    async getSupportWorkerFunction(requestParameters: GetSupportWorkerFunctionRequest): Promise<SupportWorkerFunction> {
        const response = await this.getSupportWorkerFunctionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the Enter functions executed by the worker for the specified claim.
     * Get worker functions executed for a claim
     */
    async listProviderWorkerFunctionsRaw(requestParameters: ListProviderWorkerFunctionsRequest): Promise<runtime.ApiResponse<Array<ProviderWorkerFunction>>> {
        if (requestParameters['filterClaimId'] === null || requestParameters['filterClaimId'] === undefined) {
            throw new runtime.RequiredError('filterClaimId','Required parameter requestParameters.filterClaimId was null or undefined when calling listProviderWorkerFunctions.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterClaimId !== undefined) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:function"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/functions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderWorkerFunctionFromJSON));
    }

    /**
     * Gets the Enter functions executed by the worker for the specified claim.
     * Get worker functions executed for a claim
     */
    async listProviderWorkerFunctions(requestParameters: ListProviderWorkerFunctionsRequest): Promise<Array<ProviderWorkerFunction>> {
        const response = await this.listProviderWorkerFunctionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the Enter functions executed by the worker for the specified claim.
     * Get worker functions executed for a claim
     */
    async listSupportWorkerFunctionsRaw(requestParameters: ListSupportWorkerFunctionsRequest): Promise<runtime.ApiResponse<Array<SupportWorkerFunction>>> {
        if (requestParameters['filterClaimId'] === null || requestParameters['filterClaimId'] === undefined) {
            throw new runtime.RequiredError('filterClaimId','Required parameter requestParameters.filterClaimId was null or undefined when calling listSupportWorkerFunctions.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterClaimId !== undefined) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:function", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/functions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportWorkerFunctionFromJSON));
    }

    /**
     * Gets the Enter functions executed by the worker for the specified claim.
     * Get worker functions executed for a claim
     */
    async listSupportWorkerFunctions(requestParameters: ListSupportWorkerFunctionsRequest): Promise<Array<SupportWorkerFunction>> {
        const response = await this.listSupportWorkerFunctionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the current state of the claim and runs the given rules against it to see which rule matches, if any.
     * An endpoint that will test the given rule json and a claim id to see if the result
     */
    async testDenialRuleConfigurationAgainstClaimRaw(requestParameters: TestDenialRuleConfigurationAgainstClaimRequest): Promise<runtime.ApiResponse<ClaimWorkflowStatusResponse>> {
        if (requestParameters['workerRuleTesterPayload'] === null || requestParameters['workerRuleTesterPayload'] === undefined) {
            throw new runtime.RequiredError('workerRuleTesterPayload','Required parameter requestParameters.workerRuleTesterPayload was null or undefined when calling testDenialRuleConfigurationAgainstClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/configuration/denial/rule/tester`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkerRuleTesterPayloadToJSON(requestParameters['workerRuleTesterPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowStatusResponseFromJSON(jsonValue));
    }

    /**
     * Gets the current state of the claim and runs the given rules against it to see which rule matches, if any.
     * An endpoint that will test the given rule json and a claim id to see if the result
     */
    async testDenialRuleConfigurationAgainstClaim(requestParameters: TestDenialRuleConfigurationAgainstClaimRequest): Promise<ClaimWorkflowStatusResponse> {
        const response = await this.testDenialRuleConfigurationAgainstClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the current state of the claim and runs the given rules against it to see which rule matches, if any.
     * An endpoint that will test the given rule json and a claim id to see if the result
     */
    async testDenialRuleConfigurationAgainstClaimProviderRaw(requestParameters: TestDenialRuleConfigurationAgainstClaimProviderRequest): Promise<runtime.ApiResponse<ClaimWorkflowStatusResponse>> {
        if (requestParameters['workerRuleTesterPayload'] === null || requestParameters['workerRuleTesterPayload'] === undefined) {
            throw new runtime.RequiredError('workerRuleTesterPayload','Required parameter requestParameters.workerRuleTesterPayload was null or undefined when calling testDenialRuleConfigurationAgainstClaimProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/configuration/denial/rule/tester`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkerRuleTesterPayloadToJSON(requestParameters['workerRuleTesterPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowStatusResponseFromJSON(jsonValue));
    }

    /**
     * Gets the current state of the claim and runs the given rules against it to see which rule matches, if any.
     * An endpoint that will test the given rule json and a claim id to see if the result
     */
    async testDenialRuleConfigurationAgainstClaimProvider(requestParameters: TestDenialRuleConfigurationAgainstClaimProviderRequest): Promise<ClaimWorkflowStatusResponse> {
        const response = await this.testDenialRuleConfigurationAgainstClaimProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the current state of the claim and runs the given rules against it to see which rule matches, if any.
     * An endpoint that will test the given rule json and a claim id to see if the result
     */
    async testRejectionRuleConfigurationAgainstClaimRaw(requestParameters: TestRejectionRuleConfigurationAgainstClaimRequest): Promise<runtime.ApiResponse<ClaimWorkflowStatusResponse>> {
        if (requestParameters['workerRuleTesterPayload'] === null || requestParameters['workerRuleTesterPayload'] === undefined) {
            throw new runtime.RequiredError('workerRuleTesterPayload','Required parameter requestParameters.workerRuleTesterPayload was null or undefined when calling testRejectionRuleConfigurationAgainstClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/configuration/rejection/rule/tester`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkerRuleTesterPayloadToJSON(requestParameters['workerRuleTesterPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowStatusResponseFromJSON(jsonValue));
    }

    /**
     * Gets the current state of the claim and runs the given rules against it to see which rule matches, if any.
     * An endpoint that will test the given rule json and a claim id to see if the result
     */
    async testRejectionRuleConfigurationAgainstClaim(requestParameters: TestRejectionRuleConfigurationAgainstClaimRequest): Promise<ClaimWorkflowStatusResponse> {
        const response = await this.testRejectionRuleConfigurationAgainstClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets the current state of the claim and runs the given rules against it to see which rule matches, if any.
     * An endpoint that will test the given rule json and a claim id to see if the result
     */
    async testRejectionRuleConfigurationAgainstClaimProviderRaw(requestParameters: TestRejectionRuleConfigurationAgainstClaimProviderRequest): Promise<runtime.ApiResponse<ClaimWorkflowStatusResponse>> {
        if (requestParameters['workerRuleTesterPayload'] === null || requestParameters['workerRuleTesterPayload'] === undefined) {
            throw new runtime.RequiredError('workerRuleTesterPayload','Required parameter requestParameters.workerRuleTesterPayload was null or undefined when calling testRejectionRuleConfigurationAgainstClaimProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/configuration/rejection/rule/tester`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkerRuleTesterPayloadToJSON(requestParameters['workerRuleTesterPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowStatusResponseFromJSON(jsonValue));
    }

    /**
     * Gets the current state of the claim and runs the given rules against it to see which rule matches, if any.
     * An endpoint that will test the given rule json and a claim id to see if the result
     */
    async testRejectionRuleConfigurationAgainstClaimProvider(requestParameters: TestRejectionRuleConfigurationAgainstClaimProviderRequest): Promise<ClaimWorkflowStatusResponse> {
        const response = await this.testRejectionRuleConfigurationAgainstClaimProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Updates the current claim workflow configuration for the authenticated bank user.
     * Update claim workflow configuration
     */
    async updateClaimWorkflowConfigurationRaw(requestParameters: UpdateClaimWorkflowConfigurationRequest): Promise<runtime.ApiResponse<ClaimWorkflowConfiguration>> {
        if (requestParameters['claimWorkflowConfigurationEditPayload'] === null || requestParameters['claimWorkflowConfigurationEditPayload'] === undefined) {
            throw new runtime.RequiredError('claimWorkflowConfigurationEditPayload','Required parameter requestParameters.claimWorkflowConfigurationEditPayload was null or undefined when calling updateClaimWorkflowConfiguration.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/worker/configuration`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimWorkflowConfigurationEditPayloadToJSON(requestParameters['claimWorkflowConfigurationEditPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowConfigurationFromJSON(jsonValue));
    }

    /**
     * Updates the current claim workflow configuration for the authenticated bank user.
     * Update claim workflow configuration
     */
    async updateClaimWorkflowConfiguration(requestParameters: UpdateClaimWorkflowConfigurationRequest): Promise<ClaimWorkflowConfiguration> {
        const response = await this.updateClaimWorkflowConfigurationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Updates the current claim workflow configuration for the authenticated bank user.
     * Update claim workflow configuration
     */
    async updateClaimWorkflowConfigurationProviderRaw(requestParameters: UpdateClaimWorkflowConfigurationProviderRequest): Promise<runtime.ApiResponse<ClaimWorkflowConfiguration>> {
        if (requestParameters['claimWorkflowConfigurationEditPayload'] === null || requestParameters['claimWorkflowConfigurationEditPayload'] === undefined) {
            throw new runtime.RequiredError('claimWorkflowConfigurationEditPayload','Required parameter requestParameters.claimWorkflowConfigurationEditPayload was null or undefined when calling updateClaimWorkflowConfigurationProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:grant"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/worker/configuration`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimWorkflowConfigurationEditPayloadToJSON(requestParameters['claimWorkflowConfigurationEditPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWorkflowConfigurationFromJSON(jsonValue));
    }

    /**
     * Updates the current claim workflow configuration for the authenticated bank user.
     * Update claim workflow configuration
     */
    async updateClaimWorkflowConfigurationProvider(requestParameters: UpdateClaimWorkflowConfigurationProviderRequest): Promise<ClaimWorkflowConfiguration> {
        const response = await this.updateClaimWorkflowConfigurationProviderRaw(requestParameters);
        return await response.value();
    }

}
